var render = function render(){var _vm=this,_c=_vm._self._c;return _c('preview',{attrs:{"aspect":_vm.aspect,"resolution":_vm.resolution,"url":_vm.preview_url}})
}
var staticRenderFns = []

export { render, staticRenderFns }